var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWriteit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 21.75V18.7396L20.5083 11.2312L23.5188 14.2417L16.0104 21.75H13ZM0.25 14.6667V11.8333H10.1667V14.6667H0.25ZM24.5104 13.25L21.5 10.2396L22.5271 9.2125C22.7868 8.95278 23.1174 8.82292 23.5188 8.82292C23.9201 8.82292 24.2507 8.95278 24.5104 9.2125L25.5375 10.2396C25.7972 10.4993 25.9271 10.8299 25.9271 11.2312C25.9271 11.6326 25.7972 11.9632 25.5375 12.2229L24.5104 13.25ZM0.25 9V6.16667H15.8333V9H0.25ZM0.25 3.33333V0.5H15.8333V3.33333H0.25Z",
    fill: "#5AB2AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteit);
export default __webpack_public_path__ + "static/media/writeit.3c15b6a56a295b16430482de0f1cbb5a.svg";
export { ForwardRef as ReactComponent };